import React, { useEffect, useState } from 'react';
import { Form, Typography, Select, Row, message, Col, List } from 'antd';
import GenericModal from '../../buttons/genericModal';
import { backendPatchWithoutRefresh } from '../../../helpers/callBackend';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const { Option } = Select;
const { Text } = Typography;

function EntityToBankAccountSetRelation(props) {
	const [submitting, setSubmitting] = useState(false);
	const [bankAccounts, setBankAccounts] = useState(props.bankAccounts || []);

	useEffect(() => {
		return () => {
			props.handleCancelModal();
		};
	}, []);

	useEffect(() => {
		if (props.bankAccounts === undefined) return;
		setBankAccounts(props.bankAccounts.map(bankAccountRow => ({
			bankAccountId: bankAccountRow.bankId,
			bankAccountName: bankAccountRow.account,
			entityId: bankAccountRow.entityId,
			entityName: bankAccountRow.entityName,
			entityIsConfirmed: bankAccountRow.source === "UN",
			entityIsAssigned: bankAccountRow.entityId !== "N/A",
		})))
	}, [props.bankAccounts]);

	const onFormSubmitModal = (values) => {
		let data;
		if (bankAccounts.length === 0) {
			message.error("Please select at least one bank account.");
			return;
		}
		const accountsAssignedToEntity = bankAccounts.filter(bankAccount => bankAccount.entityId !== "N/A");
		if (accountsAssignedToEntity.length > 0) {
			message.error("Please remove bank accounts that are already assigned to an entity.");
			return;
		}
		data = {
			bank_account_ids: bankAccounts.map(bankAccount => bankAccount.bankAccountId),
			entity_id: values.entity_id,
		}
		setSubmitting(true);
		backendPatchWithoutRefresh("/api/entity/bank-account/relation/", data)
			.then((res) => {
				setSubmitting(false);
				props.handleCancelModal();
				props.assignEntityToBankAccounts(data.entity_id, data.bank_account_ids);
			}).catch((err) => {
				setSubmitting(false);
			})
	};

	return (
		<GenericModal
			size='md'
			visible={props.visible}
			handleCancelModal={() => props.handleCancelModal()}
			showModal={() => props.handleShowModal()}
			modalTitle="Assign bank account(s) to an entity"
			modalBody={
				<Form
					layout="vertical"
					name="basic"
					onFinish={onFormSubmitModal}
					autoComplete="off"
				>
					<Row style={{ marginBottom: "20px" }}>
						<Text>
							Assign the following bank account(s) to an entity.
						</Text>
					</Row>

					<Row justify="center">
						<Col span={20}>
							<List
								itemLayout="horizontal"
								dataSource={bankAccounts}
								renderItem={(item) => (
									<List.Item>
										<Col span={12}>{item.bankAccountName}</Col>
										<Col span={6}>
											{item.entityIsAssigned &&
												<Typography.Text type="secondary" style={{ fontSize: '10px' }} italic>
													Already assigned, Please remove.
												</Typography.Text>}
										</Col>
										<Col span={6} align="right">
											<Button
												disableElevation fullWidth size="small" type="submit" variant="outlined" color="primary"
												sx={{ fontSize: 14, textTransform: 'none' }}
												onClick={() => {
													setBankAccounts(bankAccounts.filter(bankAccount => bankAccount.bankAccountId !== item.bankAccountId))
												}}
											>
												Remove
											</Button>
										</Col>
									</List.Item>
								)
								}
							/>
						</Col>
					</Row>
					<>
						<Row style={{ marginTop: "10px" }}>
							<Text strong>
								Select an entity to assign to these bank accounts.
							</Text>
						</Row>
						<Form.Item
							name="entity_id"
							rules={[
								{
									required: true,
									message: "Please select an entity",
								},
							]}
						>
							<Select
								showSearch
								placeholder="Select an entity"
								optionFilterProp="children"
								disabled={props.selectEntities.length === 0}
								filterOption={(input, option) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
							>
								{props.selectEntities.map((entity) => (
									<Option value={entity.id}>{entity.entity_info.name}</Option>
								))}
							</Select>
						</Form.Item>
					</>
					<Form.Item>
						<LoadingButton
							disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
							htmlType="submit"
							loadingPosition="start"
							loading={submitting}
							sx={{ fontSize: 14, textTransform: 'none' }}
							style={{ margin: "3px", width: "100%" }}
						>
							Submit
						</LoadingButton>
					</Form.Item>
				</Form>
			}
		/>
	)
}

export default EntityToBankAccountSetRelation